import { render, staticRenderFns } from "./agentAllma.vue?vue&type=template&id=1fd35de5&"
import script from "./agentAllma.vue?vue&type=script&lang=js&"
export * from "./agentAllma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports